import { TranslationType } from "../types";
import { dashboard } from "./fr/dashboard";
import { landing } from "./fr/landing";
import { story } from "./fr/story";
import { common } from "./fr/common";
import { settings } from "./fr/settings";
import { auth } from "./fr/auth";
import { navigation } from "./fr/navigation";
import { profile } from "./fr/profile";
import { errors } from "./fr/errors";

export const fr: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
